import React, { Component, useState } from "react";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";
import { PerformanceProgressTable } from "../Table/PerformanceProgressTable";
import { PerformanceChickenEgg } from "../Table/PerformanceChickenEgg";
import { PerformanceChickenMeat } from "../Table/PerformanceChickenMeat";
import { PerformancePork } from "../Table/PerformancePork";
import { PerformanceBeef } from "../Table/PerformanceBeef";
import { PerformanceOthers } from "../Table/PerformanceOthers";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function WorkProcess() {
  const handleLogout = (event) => {
    event.preventDefault();
    sessionStorage.clear("token");
    window.location = "/login";
  };

  return (
    <div>
      <div className="navbar">
        <a href="/home">
          <img className="cpf-logo" src="/assets/cpf-logo.jpg" />
        </a>
        <button className="logout-btn" onClick={handleLogout}>
          Log out
        </button>
      </div>
      <div className="global-market-container">
        <div className="performance-grid">
          <Link className="global-market-menuitem" to="/performance">
            ยอดขายโดยรวม
          </Link>
          <Link className="global-market-menuitem" to="/performance/progress">
            ผลดำเนินงาน
          </Link>
          <Link className="global-market-menuitem" to="/performance/KPIs">
            KPIs
          </Link>
        </div>
        <Accordion style={{ marginBottom: "15px" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>รวมทุกกลุ่มอาหาร</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <PerformanceProgressTable />
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion style={{ marginBottom: "15px" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>อาหารไก่ไข่</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <PerformanceChickenEgg />
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion style={{ marginBottom: "15px" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>อาหารไก่เนื้อ</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <PerformanceChickenMeat />
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion style={{ marginBottom: "15px" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>อาหารสุกร (รวม)</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <PerformancePork />
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion style={{ marginBottom: "15px" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>อาหารวัว</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <PerformanceBeef />
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion style={{ marginBottom: "15px" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>อาหารอื่น ๆ</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <PerformanceOthers />
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
}
